import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const MidwestMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='midwest-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 3000 2200'
			className={`map ${!isVisible ? 'hidden' : ''}`}>
			<polygon
				id='KS'
				points='277 2024.5 430 2027.5 643 2034.5 1223 2034.5 1213 1690.5 1152 1624.5 1152 1607.5 1176 1584.5 1171 1571.5 1130 1555.5 1117 1547.5 654.99 1547.5 300.08 1533.95 277 2024.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='KS'
				className={`polygon ${selectedState === 'KS' ? 'selected' : ''}`}
				onClick={() => handleStateClick('KS')}
			/>
			<polygon
				id='MO'
				points='1225 2113.74 1314 2113.74 1532 2106.5 1709 2094.5 1796 2090.5 1811 2104.5 1809 2131.5 1794 2146.5 1785 2161.5 1789 2171.5 1810 2167.5 1859 2168.5 1877 2122.5 1881 2091.5 1898 2062.5 1922 2055.5 1928 2022.5 1924.18 1997.3 1895.08 1997.3 1874 1965.5 1857 1892.5 1851 1877.5 1836 1863.5 1802 1859.5 1750 1805.5 1750 1772.5 1772 1729.5 1772 1712.5 1758.5 1699 1705 1699 1681 1635.5 1661 1616.5 1639 1600.5 1608 1568.5 1588 1523.5 1588 1482.5 1595 1468.5 1558 1432.5 1510 1434.5 1269 1453.5 1065 1453.5 1077 1484.5 1103 1513.5 1117 1547.5 1130 1555.5 1171 1571.5 1176 1584.5 1152 1607.5 1152 1624.5 1213 1690.5 1223 2034.5 1225 2113.74'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MO'
				className={`polygon ${selectedState === 'MO' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MO')}
			/>
			<polygon
				id='IL'
				points='1924.18 1997.3 1923 1989.5 1926 1966.5 1944.25 1953 1967 1961.5 1988 1978.5 2010 1973.5 2014 1957.5 2002 1936.5 2024 1914.5 2042 1906.5 2049 1890.5 2052 1865.5 2052 1793.07 2082 1743.5 2098 1685.5 2094 1658.5 2077 1620.5 2090 1595.5 2052.65 1204.29 2043 1190.5 2021 1146.5 2010.23 1091.21 1672 1114.5 1691 1136.5 1722 1166.5 1735 1189.5 1736 1217.5 1720 1249.5 1693 1280.5 1641 1297.5 1629 1311.5 1629 1330.21 1650 1356.5 1645 1372.5 1619 1430.5 1595 1468.5 1588 1482.5 1588 1523.5 1608 1568.5 1639 1600.5 1661 1616.5 1681 1635.5 1705 1699 1758.5 1699 1772 1712.5 1772 1729.5 1750 1772.5 1750 1805.5 1802 1859.5 1836 1863.5 1851 1877.5 1857 1892.5 1874 1965.5 1895.08 1997.3 1924.18 1997.3'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='IL'
				className={`polygon ${selectedState === 'IL' ? 'selected' : ''}`}
				onClick={() => handleStateClick('IL')}
			/>
			<polygon
				id='IN'
				points='2052 1865.5 2056 1852.5 2105 1834.5 2136 1825.5 2154 1834.5 2175 1834.5 2188 1817.5 2202 1814.5 2222 1820.5 2234 1817.5 2249.4 1782.5 2261 1777.5 2273 1787.5 2285 1794.5 2299 1798.5 2312.69 1782.5 2317 1761.5 2357 1706.5 2368 1667.5 2391 1669.5 2415 1662.5 2428 1649.5 2435 1632.5 2427 1615.5 2423 1602.5 2379 1180.5 2371 1166.5 2172 1196.5 2132.63 1195.08 2119 1206.5 2093 1220.5 2064 1220.5 2052.65 1204.29 2090 1595.5 2077 1620.5 2094 1658.5 2098 1685.5 2082 1743.5 2052 1793.07 2052 1865.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='IN'
				className={`polygon ${selectedState === 'IN' ? 'selected' : ''}`}
				onClick={() => handleStateClick('IN')}
			/>
			<polygon
				id='OH'
				points='2423 1602.5 2433 1592.5 2470 1592.5 2496 1609.5 2528 1641.5 2643 1641.5 2666 1628.5 2688 1639.5 2714 1660.5 2727 1671.5 2747 1664.5 2763 1638.5 2764 1609.5 2775 1578.5 2797 1553.5 2826 1509.5 2840 1490.5 2873 1478.5 2903 1408.5 2908 1340.5 2909 1277.5 2919.14 1273.5 2881.49 1050.82 2838 1078.5 2804 1101.5 2772 1132.5 2739 1159.5 2700 1164.5 2666 1186.5 2642 1182.5 2604 1168.5 2578 1158.5 2541 1151.5 2379 1180.5 2423 1602.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='OH'
				className={`polygon ${selectedState === 'OH' ? 'selected' : ''}`}
				onClick={() => handleStateClick('OH')}
			/>
			<g id='MI'>
				<polygon
					points='2619 872.5 2596 809.5 2570.5 774.29 2545 764.5 2515 780.5 2498 814.5 2473 843.5 2451 845.5 2433 821.5 2438 795.5 2460 779.5 2473 742.5 2492 727.5 2492 670.5 2479 646.5 2461 624.5 2463 608.5 2475 596.5 2452 574.5 2409 556.5 2367 544.5 2325 525.5 2298 515.5 2283 531.5 2271 553.5 2280 579.5 2269 590.5 2245 600.5 2217 625.5 2195 649.5 2176 674.5 2159 704.5 2159 760.5 2147 793.5 2140 820.5 2140 890.5 2157 926.5 2175 964.5 2190 1003.5 2190 1078.5 2177 1131.5 2156 1175.5 2132.63 1195.08 2172 1196.5 2371 1166.5 2379.23 1182.75 2541 1151.5 2543 1124.5 2562 1084.5 2575 1053.5 2591 1022.5 2603 990.5 2616 993.5 2623 999.5 2632 982.5 2632 925.5 2619 872.5'
					fill='#ccc'
					stroke='#fff'
					strokeMiterlimit='10'
					strokeWidth='10'
					data-area='MI'
					className={`polygon ${selectedState === 'MI' ? 'selected' : ''}`}
					onClick={() => handleStateClick('MI')}
				/>
				<polygon
					points='2180 502.5 2201 486.5 2217 478.5 2259 477.5 2292 503.5 2303 489.5 2313 480.5 2391 480.5 2386 463.5 2363 445.5 2345 412.5 2326 402.5 2303 406.5 2286 411.5 2258 411.5 2258 362.5 2235 362.5 2217 376.5 2184 387.5 2147 390.5 2120 399.5 2076 428.5 2000 428.5 1976 407.5 1937 374.5 1897 374.5 1885 388.5 1870 397.5 1870 371.5 1854 350.5 1838 338.5 1809 364.5 1783 391.5 1759 402.5 1724 404.5 1696 429.5 1665 451.5 1684 480.5 1717 498.5 1767 509.5 1825 529.5 1891.98 529.5 1917 545.5 1925 561.5 1947 568.5 1957 579.5 1957 620.5 1974 632.5 1974 657.5 1993 661.5 2006 624.5 2024 584.5 2036 550.5 2048 536.5 2055 554.5 2069 543.5 2088 532.5 2107 535.5 2120 520.5 2147 505.5 2180 502.5'
					fill='#ccc'
					stroke='#fff'
					strokeMiterlimit='10'
					strokeWidth='10'
					data-area='MI'
					className={`polygon ${selectedState === 'MI' ? 'selected' : ''}`}
					onClick={() => handleStateClick('MI')}
				/>
			</g>
			<polygon
				id='WI'
				points='2010.23 1091.21 2000 1020.5 1990 992.5 1990 925.5 1999 902.5 1999 832.5 2012 815.5 2012 768.5 2023 741.5 2025 714.5 2011 696.5 1990 718.5 1973 746.5 1957 752.5 1954 731.5 1960 714.5 1981 685.5 1993 661.5 1974 657.5 1974 632.5 1957 620.5 1957 579.5 1947 568.5 1925 561.5 1917 545.5 1891.98 529.5 1825 529.5 1767 509.5 1717 498.5 1684 480.5 1665 451.5 1642 453.5 1626 443.5 1605 447.5 1596 434.5 1607 413.5 1612 401.5 1597 391.5 1577 405.5 1557 417.5 1531 431.5 1511 441.5 1497 445.5 1466 440.5 1445 456.5 1445 542.5 1421 565.5 1398 582.5 1383 616.5 1409 655.5 1409 673.5 1403 696.5 1403 764.5 1432 793.5 1457 798.5 1472 808.5 1523 858.5 1558 879.5 1580 905.5 1591 961.5 1608 985.5 1608 1063.5 1632.13 1091.21 1658 1098.5 1672 1114.5 2010.23 1091.21'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='WI'
				className={`polygon ${selectedState === 'WI' ? 'selected' : ''}`}
				onClick={() => handleStateClick('WI')}
			/>
			<polygon
				id='MN'
				points='1591 961.5 1580 905.5 1558 879.5 1523 858.5 1472 808.5 1457 798.5 1432 793.5 1403 764.5 1403 696.5 1409 673.5 1409 655.5 1383 616.5 1398 582.5 1421 565.5 1445 542.5 1445 456.5 1466 440.5 1470 423.5 1513 386.5 1543 354.5 1575 313.5 1610 285.5 1638 268.5 1672 256.5 1703 241.5 1723 219.5 1684 217.5 1671 202.5 1597 202.5 1587 191.5 1569 191.5 1540 219.5 1517 222.5 1489 208.5 1455 181.5 1439 179.5 1431 194.5 1415 191.5 1396 169.5 1371 150.5 1344 139.5 1319 139.5 1290 158.5 1268 158.5 1260 143.5 1180 133.5 1166 110.5 1155 42.5 1133 30.5 1115 29.5 1115 85.5 894 86.5 894 114.18 902 133.5 899 194.5 903 234.5 929 309.5 939 478.5 962 527.5 964 584.5 961 603.5 935 627.5 931 639.5 943 658.5 963 676.5 976 687.5 976 978.5 1591 961.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MN'
				className={`polygon ${selectedState === 'MN' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MN')}
			/>
			<polygon
				id='ND'
				points='964 584.5 962 527.5 939 478.5 929 309.5 903 234.5 899 194.5 902 133.5 894 114.18 894 86.5 503 80.5 157 64.5 121.89 556.84 403 572.5 686.34 584.5 964 584.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='ND'
				className={`polygon ${selectedState === 'ND' ? 'selected' : ''}`}
				onClick={() => handleStateClick('ND')}
			/>
			<polygon
				id='SD'
				points='964 584.5 686.34 584.5 403 572.5 121.89 556.84 87.9 1033.38 368 1047.5 608 1056.5 742.12 1056.5 762 1081.5 790 1095.5 803.44 1095.5 818 1080.5 871 1080.5 913.42 1100 933 1104.5 964 1132.92 978 1139.5 966 1088.5 967 1063.5 978 1043.52 973 1019.5 961 990.5 962.08 978.5 976 978.5 976 687.5 963 676.5 943 658.5 931 639.5 935 627.5 961 603.5 964 584.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='SD'
				className={`polygon ${selectedState === 'SD' ? 'selected' : ''}`}
				onClick={() => handleStateClick('SD')}
			/>
			<polygon
				id='NE'
				points='1117 1547.5 1103 1513.5 1077 1484.5 1065 1453.5 1053 1412.5 1049 1332.5 1042 1311.5 1022 1293.5 1013 1239.5 978 1139.5 964 1132.92 933 1104.5 913.42 1100 871 1080.5 818 1080.5 803.44 1095.5 790 1095.5 762 1081.5 742.12 1056.5 608 1056.5 368 1047.5 87.9 1033.38 65 1354.5 308 1365.5 300.08 1533.95 654.99 1547.5 1117 1547.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NE'
				className={`polygon ${selectedState === 'NE' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NE')}
			/>
			<polygon
				id='IA'
				points='1595 1468.5 1619 1430.5 1645 1372.5 1650 1356.5 1629 1330.21 1629 1311.5 1641 1297.5 1693 1280.5 1720 1249.5 1736 1217.5 1735 1189.5 1722 1166.5 1691 1136.5 1672 1114.5 1658 1098.5 1632.13 1091.21 1608 1063.5 1608 985.5 1591 961.5 976 978.5 962.08 978.5 961 990.5 973 1019.5 978 1043.52 967 1063.5 966 1088.5 978 1139.5 1013 1239.5 1022 1293.5 1042 1311.5 1049 1332.5 1053 1412.5 1065 1453.5 1269 1453.5 1558 1432.5 1595 1468.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='IA'
				className={`polygon ${selectedState === 'IA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('IA')}
			/>
			<rect x='876' y='1651.5' width='161.13' height='41' fill='none' className='shape' />
			<path
				d='M928.42,1663.11h-7.09l.51-2.59h17.18l-.5,2.59h-7.12l-4.11,21.67h-2.98l4.11-21.67Z'
				className='shape'
			/>
			<path
				d='M954.53,1674.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM941.14,1677.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M957.93,1691.91l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.07l-1.41,7.51h-2.97ZM962.83,1681.86c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.81-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M993.94,1683.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM990.64,1669.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1000.58,1684.78l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.96-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<path
				d='M1030.91,1684.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1032.84,1669.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<polygon
				points='1079.38 1694.58 1079.75 1709.5 1095.44 1709.5 1079.98 1718.72 1080.35 1733.65 1070.42 1724.42 1054.96 1733.65 1064.29 1718.72 1054.36 1709.5 1070.05 1709.5 1079.38 1694.58'
				className='shape'
			/>
			<rect x='1210' y='1801.5' width='307' height='43' fill='none' className='shape' />
			<path
				d='M1290.85,1833c.79.33,1.77.53,3.05.53,2.54,0,4.16-1.34,4.97-5.64l3.11-16.37h2.98l-3.17,16.69c-1.07,5.68-3.44,7.96-7.98,7.96-1.47,0-2.99-.31-3.6-.63l.65-2.55Z'
				className='shape'
			/>
			<path
				d='M1320.99,1834.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1317.69,1820.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1350.27,1812.68c-.46-.22-1.07-.34-1.75-.34-2.37,0-3.53,2.32-4.04,5.19l-.15.83h3.88l-.46,2.34h-3.87l-2.85,15.06h-2.98l2.86-15.06h-7.05l-2.85,15.06h-2.97l2.86-15.06h-2.32l.45-2.34h2.33l.15-.79c.4-2.07,1.16-4.25,2.61-5.7,1.02-1.01,2.39-1.66,4.21-1.66.91,0,1.68.23,2.25.52l-.91,2.31c-.37-.2-.9-.34-1.44-.34-2.37,0-3.31,2.42-3.79,4.95l-.14.72h7.07l.17-.93c.43-2.42,1.29-4.66,2.85-6.07,1.1-.99,2.62-1.54,4.13-1.54,1.2,0,1.98.23,2.39.47l-.65,2.39Z'
				className='shape'
			/>
			<path
				d='M1363.18,1834.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1359.88,1820.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1369.81,1835.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.49,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1384.28,1832.76c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.01-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.11,1.13-3.11,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1417.15,1825.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1403.76,1828.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1422.12,1835.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1470.53,1835c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.83-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M1476.48,1835.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1480.35,1813.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1495.39,1813.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M1505.94,1818.37l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.57c.75-.26,2.01-.75,3.19-1.67,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='1533.38 1752.58 1533.75 1767.5 1549.44 1767.5 1533.98 1776.72 1534.35 1791.65 1524.42 1782.42 1508.96 1791.65 1518.29 1776.72 1508.36 1767.5 1524.05 1767.5 1533.38 1752.58'
				className='shape'
			/>
			<rect x='1538' y='1508.5' width='254.42' height='38' fill='none' className='shape' />
			<path
				d='M1613.13,1536.53c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.2-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M1630.81,1547.41l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.07l-1.41,7.51h-2.97ZM1635.71,1537.36c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.81-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M1654.16,1540.28l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1668.45,1540.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1672.33,1518.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1679.58,1540.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1701.83,1544.23c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.52,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM1715.21,1525.46c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<path
				d='M1723.84,1540.28l2.85-15.06h-2.32l.45-2.34h2.33l.16-.9c.86-4.76,3.79-7.65,8.33-7.65,1.63,0,3.33.47,3.95.92l-.93,2.36c-.74-.39-1.99-.79-3.45-.79-3.12,0-4.49,2.4-4.97,5.23l-.14.83h9.35l-3.32,17.41h-2.98l2.85-15.06h-6.35l-2.85,15.06h-2.95Z'
				className='shape'
			/>
			<path
				d='M1756.79,1539.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1753.48,1524.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path d='M1763.43,1540.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1793.06,1514.72l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM1788.05,1525.6c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<polygon
				points='1824.67 1545.58 1825.04 1560.5 1840.73 1560.5 1825.26 1569.72 1825.63 1584.65 1815.71 1575.42 1800.25 1584.65 1809.57 1569.72 1799.65 1560.5 1815.34 1560.5 1824.67 1545.58'
				className='shape'
			/>
			<rect x='1947' y='1457.5' width='290.42' height='44' fill='none' className='shape' />
			<path d='M2035.07,1468.02l-4.62,24.26h-2.98l4.61-24.26h2.98Z' className='shape' />
			<path
				d='M2038.68,1492.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2079.3,1466.72l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM2074.29,1477.6c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<path
				d='M2082.57,1492.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2086.44,1470.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2105.23,1492.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2107.17,1477.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M2115.43,1492.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2154.24,1481.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2140.85,1485.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M2157.64,1499.41l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.08l-1.41,7.51h-2.97ZM2162.54,1489.36c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.8-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M2197.8,1481.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.7,0,6.81,3.55,6.81,7.24ZM2184.41,1485.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path d='M2202.78,1492.28l4.88-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M2213.89,1492.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2217.77,1470.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2225.16,1489.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.01-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.11,1.13-3.11,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.97,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<polygon
				points='2267.67 1504.58 2268.04 1519.5 2283.73 1519.5 2268.26 1528.72 2268.63 1543.65 2258.71 1534.42 2243.25 1543.65 2252.57 1528.72 2242.65 1519.5 2258.34 1519.5 2267.67 1504.58'
				className='shape'
			/>
			<rect x='2208' y='1052.5' width='183' height='47' fill='none' className='shape' />
			<path
				d='M2265.81,1064.52h2.98l-4.14,21.67h9.79l-.5,2.59h-12.75l4.62-24.26Z'
				className='shape'
			/>
			<path
				d='M2291.32,1088.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2293.25,1073.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.43-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M2301.52,1088.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2323.77,1085.76c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.01-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.11,1.13-3.11,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.97,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M2339.93,1088.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2343.81,1066.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2351.05,1088.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2373.31,1092.73c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.53,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM2386.69,1073.96c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<polygon
				points='2390.67 1015.58 2391.04 1030.5 2406.73 1030.5 2391.26 1039.72 2391.63 1054.65 2381.71 1045.42 2366.25 1054.65 2375.57 1039.72 2365.65 1030.5 2381.34 1030.5 2390.67 1015.58'
				className='shape'
			/>
			<rect x='2379' y='1369.5' width='233' height='38' fill='none' className='shape' />
			<path
				d='M2463.68,1400.5c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.99-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M2486.12,1390.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2472.74,1394.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path d='M2491.1,1401.28l4.87-25.56h2.99l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M2519.2,1383.87l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.18.97-.29,1.8-.29,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M2524.03,1401.28l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.8-.11,1.97-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.51-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M2563.67,1375.72l-2.3,11.3.07.02c1.55-2.35,3.78-3.56,6.12-3.56,3.82,0,5.27,3.15,5.27,6.24,0,5.36-3.87,11.96-10.85,11.96-3.07,0-5.37-1.28-5.36-4.49,0-.85.14-1.87.3-2.7l3.75-18.76h2.99ZM2559.9,1394.55c-.12.59-.23,1.28-.21,2.21.02,1.66.96,2.57,2.82,2.57,4.51,0,7.23-5.36,7.23-9.22,0-2.16-.94-4.15-3.32-4.15-2.57,0-5.25,2.67-6.12,6.74l-.39,1.85Z'
				className='shape'
			/>
			<path
				d='M2594.76,1383.87l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.34-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M2599.74,1398.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.83,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<polygon
				points='2637.67 1401.58 2638.04 1416.5 2653.73 1416.5 2638.26 1425.72 2638.63 1440.65 2628.71 1431.42 2613.25 1440.65 2622.57 1425.72 2612.65 1416.5 2628.34 1416.5 2637.67 1401.58'
				className='shape'
			/>
			<rect x='1582' y='1033.5' width='197.79' height='38' fill='none' className='shape' />
			<path
				d='M1658.5,1065.28l1.74-13.1c.31-2.31.85-5.87,1.31-8.21h-.11c-1.12,2.45-2.47,5.33-3.8,7.82l-7.21,13.34h-2.28l-1.79-13.07c-.37-2.79-.62-5.6-.78-8.09h-.08c-.51,2.24-1.27,5.91-1.85,8.22l-3.3,13.09h-2.81l6.28-24.26h3.81l1.92,13.91c.24,2.06.52,4.28.58,6.08h.11c.74-1.8,1.78-3.98,2.82-6l7.51-14h3.9l-3.08,24.26h-2.91Z'
				className='shape'
			/>
			<path
				d='M1680.58,1065.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1682.52,1050.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1709.22,1039.72l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM1704.21,1050.6c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<path
				d='M1712.49,1065.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1716.37,1043.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1723.76,1062.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1756.62,1054.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1743.24,1058.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1761.59,1065.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='1819.04 1011.58 1819.41 1026.5 1835.1 1026.5 1819.64 1035.72 1820.01 1050.65 1810.08 1041.42 1794.62 1050.65 1803.95 1035.72 1794.02 1026.5 1809.71 1026.5 1819.04 1011.58'
				className='shape'
			/>
			<rect x='1038' y='1264.5' width='255.79' height='38' fill='none' className='shape' />
			<path
				d='M1109.5,1272.34c1.86-.32,3.91-.49,6.03-.49,4.05,0,7.13,1.15,8.93,3.23,1.31,1.35,2.27,3.52,2.28,6.58,0,4.39-1.75,8.74-4.87,11.4-2.81,2.36-6.34,3.38-11,3.38-2.12,0-4.31-.12-5.89-.3l4.52-23.79ZM1108.42,1293.8c1.09.14,2.23.17,3.13.17,3.85,0,6.66-1.13,8.68-3.22,2.18-2.23,3.31-5.54,3.31-8.95,0-4.29-2.1-7.5-8.15-7.5-1.08,0-2.44.07-3.31.25l-3.66,19.25Z'
				className='shape'
			/>
			<path
				d='M1143.97,1295.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1140.67,1280.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1150.75,1293.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1196.76,1296.28l1.74-13.1c.31-2.31.85-5.87,1.31-8.21h-.11c-1.12,2.45-2.47,5.33-3.8,7.82l-7.21,13.34h-2.28l-1.79-13.07c-.37-2.79-.62-5.6-.78-8.09h-.08c-.51,2.24-1.27,5.91-1.85,8.22l-3.3,13.09h-2.81l6.28-24.26h3.81l1.92,13.91c.24,2.06.52,4.28.58,6.08h.11c.74-1.8,1.78-3.98,2.82-6l7.51-14h3.9l-3.08,24.26h-2.91Z'
				className='shape'
			/>
			<path
				d='M1224.01,1285.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1210.62,1289.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1228.97,1296.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1232.85,1274.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1240.1,1296.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1274.75,1295.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1271.45,1280.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1281.53,1293.26c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<polygon
				points='1326.04 1280.58 1326.41 1295.5 1342.1 1295.5 1326.64 1304.72 1327.01 1319.65 1317.08 1310.42 1301.62 1319.65 1310.95 1304.72 1301.02 1295.5 1316.71 1295.5 1326.04 1280.58'
				className='shape'
			/>
			<rect x='1176' y='771.5' width='173.79' height='38' fill='none' className='shape' />
			<path
				d='M1225.54,799.53c1.32.89,3.14,1.55,5.16,1.55,2.73,0,5.24-1.63,5.24-4.55,0-1.8-1.02-3.15-3.55-4.54-3.1-1.68-4.83-3.62-4.83-6.22,0-4.34,3.73-7.12,8.19-7.12,2.37,0,4.14.69,4.97,1.26l-1.06,2.44c-.76-.46-2.28-1.16-4.21-1.14-3,0-4.8,1.97-4.81,3.96,0,1.97,1.23,3.09,3.77,4.5,2.99,1.6,4.63,3.51,4.63,6.49,0,4.2-3.29,7.5-8.75,7.5-2.43,0-4.82-.79-5.84-1.69l1.08-2.44Z'
				className='shape'
			/>
			<path
				d='M1252.52,781.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.76Z'
				className='shape'
			/>
			<path
				d='M1258.53,801.54c0-1.33.94-2.42,2.27-2.42,1.23,0,2.01.92,2.01,2.16,0,1.32-.94,2.38-2.28,2.38-1.21,0-2-.93-2-2.12Z'
				className='shape'
			/>
			<path
				d='M1283.36,779.38c1.36-.32,3.3-.52,5.26-.52,2.34,0,4.59.56,5.95,1.87,1.15,1.06,1.76,2.48,1.76,4.39,0,2.71-1.33,4.99-2.91,6.31-1.87,1.58-4.62,2.32-7.35,2.32-.91,0-1.71-.06-2.47-.19l-1.85,9.72h-2.94l4.55-23.9ZM1284.06,791.04c.85.18,1.54.24,2.42.24,4.09,0,6.84-2.54,6.84-5.96,0-2.9-2.06-4.04-4.83-4.04-1.18,0-2.08.1-2.61.26l-1.81,9.5Z'
				className='shape'
			/>
			<path
				d='M1310.63,803.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1312.56,788.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1337.74,785.87l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path d='M1342.58,803.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<polygon
				points='1387.04 728.58 1387.41 743.5 1403.1 743.5 1387.64 752.72 1388.01 767.65 1378.08 758.42 1362.62 767.65 1371.95 752.72 1362.02 743.5 1377.71 743.5 1387.04 728.58'
				className='shape'
			/>
			<rect x='375' y='776.5' width='136.79' height='51' fill='none' className='shape' />
			<path
				d='M421.71,790.88c1.36-.32,3.3-.52,5.26-.52,2.34,0,4.59.56,5.95,1.87,1.15,1.06,1.76,2.48,1.76,4.39,0,2.71-1.33,4.99-2.91,6.31-1.87,1.58-4.62,2.32-7.35,2.32-.91,0-1.71-.06-2.47-.19l-1.85,9.72h-2.94l4.55-23.9ZM422.41,802.54c.85.18,1.54.24,2.42.24,4.09,0,6.84-2.54,6.84-5.96,0-2.9-2.06-4.04-4.83-4.04-1.18,0-2.08.1-2.61.26l-1.81,9.5Z'
				className='shape'
			/>
			<path
				d='M437.79,814.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM441.67,792.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M461.47,813.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM458.17,799.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M468.1,814.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M482.4,814.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M509.06,813.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.46,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM505.76,799.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.05,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='544.04 825.58 544.41 840.5 560.1 840.5 544.64 849.72 545.01 864.65 535.08 855.42 519.62 864.65 528.95 849.72 519.02 840.5 534.71 840.5 544.04 825.58'
				className='shape'
			/>
			<rect x='756' y='1372.5' width='164.79' height='38' fill='none' className='shape' />
			<path
				d='M804.71,1380.02h2.99l-4.14,21.67h9.79l-.5,2.59h-12.75l4.61-24.26Z'
				className='shape'
			/>
			<path
				d='M818.78,1404.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM822.66,1382.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M829.91,1404.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M863.99,1403.59c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M886.5,1393.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM873.11,1397.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path d='M891.48,1404.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M902.59,1404.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.81,6.46-3.81,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='963.04 1411.58 963.41 1426.5 979.1 1426.5 963.64 1435.72 964.01 1450.65 954.08 1441.42 938.62 1450.65 947.95 1435.72 938.02 1426.5 953.71 1426.5 963.04 1411.58'
				className='shape'
			/>
			<rect x='518.79' y='382.5' width='179.21' height='43' fill='none' className='shape' />
			<path
				d='M524.45,392.86c1.48-.3,3.23-.5,5.2-.5,2.5,0,4.31.5,5.6,1.66,1.12.91,1.74,2.2,1.74,3.78,0,3.07-2.47,5.34-5.22,6.05v.1c2.19.64,4,2.46,3.98,5.38,0,2.48-1.32,4.43-2.9,5.62-1.93,1.44-4.6,1.99-7.85,1.99-2.08,0-3.89-.13-5.03-.34l4.49-23.74ZM523.31,414.37c.76.12,1.64.16,2.45.16,3.53.02,6.85-1.46,6.85-5.34,0-2.85-2.4-4.1-5.12-4.1h-2.43l-1.75,9.28ZM525.53,402.81h2.22c3.48,0,6.16-1.8,6.16-4.75,0-2.34-1.76-3.33-4.4-3.33-1.1,0-2.01.08-2.48.22l-1.5,7.86Z'
				className='shape'
			/>
			<path
				d='M541.34,416.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM545.22,394.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.88c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M552.61,413.76c.82.49,2.31,1.08,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.62,0,1.28.84,2.05,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M568.77,416.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.8-.11,1.97-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.51-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M612.29,416.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM614.22,401.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M622.49,416.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.17l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M636.78,416.78l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.96-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<polygon
				points='504.04 425.58 504.41 440.5 520.1 440.5 504.64 449.72 505.01 464.65 495.08 455.42 479.62 464.65 488.95 449.72 479.02 440.5 494.71 440.5 504.04 425.58'
				className='shape'
			/>
			<rect
				x='335.86'
				y='240.92'
				width='465.14'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M338.1,293.12l9.23-48.53h6.54l11.12,27.48c2.15,5.52,3.24,9.36,4.26,13.53l.16-.08c.26-4.36.77-8.39,2.03-15.19l4.9-25.75h5.65l-9.23,48.53h-5.9l-11.06-27.43c-2.37-6-3.45-9.4-4.5-14l-.21.08c-.53,4.53-1.31,9.39-2.55,15.99l-4.79,25.37h-5.63Z'
				className='shape'
			/>
			<path
				d='M422.58,271.98c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM395.8,279.37c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M432.51,293.12l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.56,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.63-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M478.62,248.93l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.54l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M491.33,293.12l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M563.72,245.23c3.73-.65,7.81-.97,12.06-.97,8.09,0,14.27,2.3,17.86,6.45,2.61,2.71,4.53,7.04,4.56,13.16,0,8.79-3.49,17.49-9.74,22.81-5.61,4.71-12.69,6.76-22,6.76-4.23,0-8.62-.24-11.77-.61l9.03-47.6ZM561.55,288.15c2.18.29,4.47.34,6.27.34,7.71,0,13.32-2.27,17.37-6.45,4.37-4.46,6.62-11.07,6.62-17.9,0-8.59-4.2-15.01-16.3-15.01-2.17,0-4.88.13-6.62.5l-7.33,38.52Z'
				className='shape'
			/>
			<path
				d='M630.56,293.12c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM634.43,262.75c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M650.82,293.12l9.72-51.12h5.94l-6.12,32.05h.14c1.06-1.22,2.35-2.55,3.26-3.51l12.27-12.24h7.38l-15.19,14.29,10.4,20.53h-6.57l-8.39-17.19-4.41,3.93-2.5,13.26h-5.92Z'
				className='shape'
			/>
			<path
				d='M721.81,271.98c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM695.03,279.37c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M747.32,248.93l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.25-4.01.76-6.54l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M783.05,293.12c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM786.92,262.75c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.02,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='232.84'
				y='688.68'
				width='465.14'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M235.83,733.37c2.64,1.78,6.27,3.1,10.33,3.1,5.46.01,10.49-3.26,10.49-9.11,0-3.61-2.03-6.29-7.1-9.07-6.2-3.35-9.66-7.23-9.66-12.45,0-8.69,7.46-14.25,16.39-14.25,4.74,0,8.27,1.38,9.94,2.52l-2.12,4.88c-1.53-.92-4.56-2.31-8.42-2.28-5.99,0-9.61,3.95-9.62,7.93,0,3.94,2.46,6.18,7.54,9,5.98,3.2,9.26,7.03,9.26,12.99,0,8.39-6.59,15-17.51,15-4.85,0-9.65-1.59-11.67-3.37l2.16-4.89Z'
				className='shape'
			/>
			<path
				d='M308.33,719.74c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM281.55,727.13c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M352.23,706.05l-4.69,24.69c-.73,3.87-1.22,7.25-1.56,10.13h-5.39l.9-6.57h-.14c-3.1,4.53-7.69,7.36-12.29,7.36s-9.2-2.16-9.2-10.08c0-1.67.21-3.55.67-5.86l3.76-19.67h5.96l-3.7,19.41c-.37,1.94-.59,3.61-.59,5.11,0,3.6,1.48,6.06,5.56,6.06,4.35,0,9.9-5.08,11.35-12.72l3.39-17.86h5.96Z'
				className='shape'
			/>
			<path
				d='M377.48,696.69l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.54l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M390.18,740.87l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M462.57,692.99c3.73-.65,7.81-.97,12.06-.97,8.09,0,14.27,2.3,17.86,6.45,2.61,2.71,4.53,7.04,4.56,13.16,0,8.79-3.49,17.49-9.74,22.81-5.61,4.71-12.69,6.76-22,6.76-4.23,0-8.62-.24-11.77-.61l9.03-47.6ZM460.4,735.91c2.18.29,4.47.34,6.27.34,7.71,0,13.32-2.27,17.37-6.45,4.37-4.46,6.62-11.07,6.62-17.9,0-8.59-4.2-15.01-16.3-15.01-2.17,0-4.88.13-6.62.5l-7.33,38.52Z'
				className='shape'
			/>
			<path
				d='M529.41,740.87c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM533.28,710.51c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M549.67,740.87l9.72-51.12h5.94l-6.12,32.05h.14c1.06-1.22,2.35-2.55,3.26-3.51l12.27-12.24h7.38l-15.19,14.29,10.4,20.53h-6.57l-8.38-17.19-4.41,3.93-2.5,13.26h-5.92Z'
				className='shape'
			/>
			<path
				d='M620.66,719.74c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM593.88,727.13c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M646.18,696.69l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.25-4.01.76-6.54l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M681.9,740.87c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM685.78,710.51c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.02,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='1018.84'
				y='502.68'
				width='362.16'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1061.74,554.87l3.48-26.21c.63-4.63,1.71-11.74,2.63-16.42h-.23c-2.24,4.9-4.95,10.67-7.59,15.64l-14.42,26.69h-4.57l-3.59-26.14c-.74-5.57-1.23-11.21-1.56-16.18h-.16c-1.02,4.48-2.54,11.81-3.7,16.44l-6.6,26.19h-5.62l12.57-48.53h7.62l3.84,27.83c.48,4.12,1.04,8.56,1.17,12.17h.22c1.48-3.61,3.56-7.96,5.65-12l15.02-28h7.81l-6.16,48.53h-5.81Z'
				className='shape'
			/>
			<path
				d='M1083.24,554.87l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1090.99,510.33c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1105.48,554.87l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1149.69,554.87l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1219.01,552.88c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.17,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM1212.41,523.91c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.86-2.18-4.43-5.3-4.43Z'
				className='shape'
			/>
			<path
				d='M1232.56,548.82c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M1298.31,533.74c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1271.53,541.13c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1323.82,510.69l-1.79,9.36h8.32l-.93,4.67h-8.33l-3.21,16.93c-.38,1.95-.69,3.74-.69,5.56,0,2.08.99,3.38,3.3,3.38,1.07,0,2.03-.08,2.81-.28l-.29,4.7c-1.06.41-2.88.63-4.62.63-5.26,0-7.33-3.19-7.33-6.76,0-2.03.26-4.01.76-6.54l3.4-17.62h-4.98l.9-4.67h5l1.47-7.85,6.2-1.51Z'
				className='shape'
			/>
			<path
				d='M1359.55,554.87c-.02-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1363.42,524.51c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='416.83'
				y='1244.9'
				width='316.17'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M419.07,1297.09l9.23-48.53h6.54l11.12,27.48c2.15,5.52,3.24,9.36,4.26,13.53l.16-.08c.26-4.36.77-8.39,2.03-15.19l4.9-25.75h5.65l-9.23,48.53h-5.9l-11.06-27.43c-2.37-6-3.45-9.4-4.5-14l-.21.08c-.53,4.53-1.31,9.39-2.55,15.99l-4.79,25.37h-5.63Z'
				className='shape'
			/>
			<path
				d='M495.25,1295.1c-2.63,1.48-6.84,2.75-11.51,2.75-9.25,0-13.25-6.3-13.25-14.01,0-10.49,7.79-22.36,19-22.36,6.63,0,10.22,3.95,10.23,8.93,0,9.15-10.31,11.55-23.18,11.31-.29,1.51-.09,4.76.7,6.63,1.4,3.14,4.17,4.68,7.75,4.68,4.14,0,7.25-1.23,9.38-2.39l.88,4.45ZM488.65,1266.13c-5.69,0-9.98,5.55-11.44,11,9.38.11,16.73-1.14,16.73-6.57,0-2.87-2.18-4.44-5.3-4.44Z'
				className='shape'
			/>
			<path
				d='M523.86,1245.97l-4.6,22.6.14.04c3.09-4.69,7.56-7.13,12.25-7.13,7.63,0,10.55,6.3,10.55,12.47,0,10.72-7.74,23.93-21.7,23.93-6.13,0-10.74-2.55-10.73-8.98,0-1.7.28-3.74.61-5.41l7.5-37.52h5.98ZM516.31,1283.63c-.24,1.18-.46,2.56-.43,4.41.03,3.31,1.93,5.14,5.64,5.14,9.02,0,14.47-10.71,14.47-18.44,0-4.32-1.88-8.3-6.65-8.3-5.14,0-10.5,5.34-12.25,13.49l-.78,3.7Z'
				className='shape'
			/>
			<path
				d='M552.07,1297.09l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.56,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.63-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M602.74,1297.09c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.29-1.47,16.14h-5.57ZM606.61,1266.73c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M623.42,1291.04c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.2,6.5,5.24,6.5,9.15,0,7.32-5.95,11.47-13.3,11.47-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M655.76,1297.09l9.72-51.12h5.94l-6.12,32.05h.14c1.06-1.22,2.35-2.55,3.26-3.51l12.27-12.24h7.38l-15.19,14.29,10.4,20.53h-6.57l-8.39-17.19-4.41,3.93-2.5,13.26h-5.92Z'
				className='shape'
			/>
			<path
				d='M716.42,1297.09c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.29-1.47,16.14h-5.57ZM720.3,1266.73c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='1150.39'
				y='1130.9'
				width='169.61'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path d='M1167.75,1134.56l-9.24,48.53h-5.96l9.23-48.53h5.97Z' className='shape' />
			<path
				d='M1208.38,1161.96c0,10.76-7.64,21.93-19.35,21.93-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1181.6,1169.35c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.21,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1226.05,1148.27l1.23,19.58c.27,4.3.24,6.54.17,9.37h.16c.83-2.27,2.09-5.26,3.82-8.74l10.36-20.21h5.2l2.2,19.84c.35,3.83.59,6.8.55,9.11h.17c.93-2.81,1.88-5.5,3.29-8.84l9.4-20.12h6.08l-17.21,34.82h-5.55l-2.3-18.92c-.34-3.23-.53-6.2-.51-9.27h-.15c-1.46,3.35-2.46,6-4.04,9.09l-9.99,19.1h-5.58l-3.21-34.82h5.89Z'
				className='shape'
			/>
			<path
				d='M1296.33,1183.09c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM1300.21,1152.73c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='575.39'
				y='1752.9'
				width='238.61'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M586.86,1756.56h5.92l-4.48,23.61.31-.04c1.67-2.08,3.31-3.78,4.79-5.45l17.08-18.12h7.47l-20.42,20.88,12.46,27.66h-6.49l-10.63-23.83-5.79,5.4-3.54,18.43h-5.9l9.23-48.53Z'
				className='shape'
			/>
			<path
				d='M643.43,1805.09c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM647.31,1774.73c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M663.83,1805.09l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M708.33,1799.04c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.47-13.3,11.47-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M763.74,1805.09c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM767.62,1774.73c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M784.43,1799.04c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.47-13.3,11.47-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<rect
				x='1307.18'
				y='1632.17'
				width='291.82'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1350.07,1684.37l3.48-26.21c.63-4.63,1.71-11.74,2.63-16.42h-.23c-2.24,4.9-4.95,10.67-7.59,15.64l-14.42,26.69h-4.57l-3.59-26.14c-.74-5.57-1.23-11.21-1.56-16.18h-.16c-1.02,4.48-2.54,11.81-3.7,16.44l-6.6,26.2h-5.62l12.57-48.53h7.62l3.84,27.83c.48,4.12,1.04,8.56,1.17,12.17h.22c1.47-3.61,3.55-7.96,5.65-12l15.02-28h7.81l-6.16,48.53h-5.81Z'
				className='shape'
			/>
			<path
				d='M1371.57,1684.37l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1379.32,1639.82c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1394.11,1678.32c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.95.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M1426.72,1678.32c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.29-5.31-6.29-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.67,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M1492.46,1663.24c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1465.68,1670.63c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1536.36,1649.55l-4.69,24.69c-.73,3.87-1.22,7.25-1.56,10.14h-5.39l.9-6.57h-.14c-3.1,4.53-7.69,7.36-12.29,7.36s-9.2-2.16-9.2-10.08c0-1.67.21-3.55.67-5.86l3.76-19.67h5.96l-3.7,19.41c-.37,1.94-.59,3.61-.59,5.11,0,3.6,1.48,6.06,5.56,6.06,4.35,0,9.9-5.08,11.34-12.72l3.39-17.86h5.96Z'
				className='shape'
			/>
			<path
				d='M1546.02,1684.37l4.26-22.43c.85-4.54,1.38-9.16,1.77-12.39h5.26c-.28,2.42-.57,4.85-.97,7.57h.21c2.28-4.77,6-8.36,10.67-8.36.55,0,1.24.04,1.71.13l-1.16,5.89c-.42-.08-.95-.12-1.62-.12-5.17,0-9.77,6.27-11.28,14.35l-2.88,15.36h-5.96Z'
				className='shape'
			/>
			<path
				d='M1574.61,1684.37l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1582.36,1639.82c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<rect
				x='1562.09'
				y='726.21'
				width='338.91'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1571.48,778.41l-2.38-48.53h6l1.03,29.09c.18,6.28.06,9.59,0,12.64h.17c1.13-3.17,2.31-6.32,4.99-12.3l13.44-29.43h6.39l1,27.93c.22,6.29.22,10.5.11,13.7h.16c1.43-4.17,2.88-8.07,4.74-12.49l13.08-29.14h6.26l-22.52,48.53h-6.32l-1.24-27.61c-.26-5.64-.2-8.4.11-13.96h-.18c-1.62,4.65-2.91,8.37-4.9,12.77l-13.54,28.8h-6.4Z'
				className='shape'
			/>
			<path
				d='M1629,778.41l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1636.76,733.87c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1651.54,772.36c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.47-13.3,11.47-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M1707.82,777.03c-1.78.88-5.39,2.14-10.12,2.14-8.96,0-13.39-6.07-13.39-13.47,0-11.88,8.84-22.89,21.36-22.89,3.25,0,6.18.95,7.24,1.58l-1.71,4.74c-1.38-.66-3.29-1.31-5.92-1.31-9.04,0-14.76,8.92-14.76,17.13,0,5.66,2.96,9.31,8.67,9.31,3.54,0,6.26-1.09,8.05-1.94l.58,4.72Z'
				className='shape'
			/>
			<path
				d='M1752.85,757.28c0,10.76-7.64,21.93-19.35,21.93-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1726.07,764.67c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.21,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1762.78,778.41l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1807.27,772.36c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.47-13.3,11.47-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<path
				d='M1839.6,778.41l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1847.35,733.87c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1861.85,778.41l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.81,2.38,8.81,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<rect
				x='1680.67'
				y='1405.51'
				width='238.33'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path d='M1698.03,1409.18l-9.24,48.53h-5.96l9.23-48.53h5.97Z' className='shape' />
			<path d='M1705.26,1457.71l9.75-51.12h5.97l-9.76,51.12h-5.96Z' className='shape' />
			<path d='M1727.51,1457.71l9.75-51.12h5.97l-9.76,51.12h-5.96Z' className='shape' />
			<path
				d='M1749.74,1457.71l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1757.5,1413.16c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1771.99,1457.71l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M1849.61,1436.58c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.31-22.11,9.39,0,13.63,7.1,13.63,14.48ZM1822.83,1443.97c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.2,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
			<path
				d='M1859.54,1457.71l6.65-34.82h5.96l-6.65,34.82h-5.96ZM1867.29,1413.16c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M1882.08,1451.66c1.64.98,4.62,2.17,7.49,2.17,4.02,0,6.63-2.6,6.63-5.69,0-2.72-1.22-4.42-4.84-6.42-4.03-2.23-6.3-5.31-6.3-8.88,0-6.08,5.28-10.74,12.62-10.74,3.16,0,5.94.85,7.25,1.73l-1.68,4.51c-1.2-.7-3.4-1.59-6-1.59-3.64,0-6.21,2.27-6.21,5.23,0,2.56,1.67,4.11,4.79,5.86,3.88,2.19,6.5,5.24,6.5,9.15,0,7.32-5.95,11.48-13.3,11.48-3.75,0-7.08-1.18-8.66-2.39l1.71-4.42Z'
				className='shape'
			/>
			<rect
				x='2097.67'
				y='1357.51'
				width='263.33'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path d='M2115.03,1361.18l-9.24,48.53h-5.96l9.23-48.53h5.97Z' className='shape' />
			<path
				d='M2122.25,1409.71l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M2203.49,1358.58l-7.64,40.08c-.67,3.61-1.26,7.67-1.47,11.04h-5.47l.93-6.89h-.14c-3.18,4.94-7.56,7.68-12.56,7.68-6.72,0-10.4-5.52-10.4-12.67,0-12.38,9.2-23.73,21.54-23.73,2.19,0,4.64.47,6.15,1.19l3.12-16.7h5.94ZM2193.47,1380.34c-1.21-.82-3.2-1.48-5.7-1.48-8.36,0-14.85,8.9-14.85,18.15,0,4.22,1.44,8.59,6.57,8.59,4.58,0,10.15-5.25,11.65-13.08l2.33-12.18Z'
				className='shape'
			/>
			<path
				d='M2210.02,1409.71l6.65-34.82h5.96l-6.65,34.82h-5.96ZM2217.77,1365.16c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M2255.35,1409.71c-.03-2.1.33-5.39.78-9h-.16c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.92-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM2259.23,1379.34c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.41,19.07-.03,3.89,1.35,7.68,5.94,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M2275.75,1409.71l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<path
				d='M2343.05,1409.71c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM2346.92,1379.34c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<rect
				x='2200.67'
				y='868.51'
				width='317.33'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M2243.57,920.71l3.48-26.21c.63-4.63,1.71-11.74,2.63-16.42h-.23c-2.24,4.9-4.95,10.67-7.59,15.64l-14.42,26.69h-4.57l-3.59-26.14c-.74-5.57-1.23-11.21-1.56-16.18h-.16c-1.03,4.48-2.54,11.81-3.7,16.44l-6.6,26.19h-5.62l12.57-48.53h7.62l3.84,27.83c.48,4.12,1.04,8.56,1.17,12.17h.22c1.48-3.61,3.56-7.96,5.65-12l15.03-28h7.81l-6.16,48.53h-5.81Z'
				className='shape'
			/>
			<path
				d='M2265.06,920.71l6.65-34.82h5.96l-6.65,34.82h-5.96ZM2272.82,876.16c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M2311.27,919.33c-1.78.88-5.38,2.14-10.12,2.14-8.96,0-13.39-6.07-13.39-13.47,0-11.88,8.84-22.89,21.36-22.89,3.25,0,6.18.95,7.24,1.58l-1.71,4.74c-1.38-.66-3.29-1.31-5.92-1.31-9.04,0-14.76,8.92-14.76,17.13,0,5.66,2.96,9.31,8.67,9.31,3.54,0,6.26-1.09,8.05-1.94l.58,4.72Z'
				className='shape'
			/>
			<path
				d='M2323.53,920.71l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M2367.74,920.71l6.65-34.82h5.96l-6.65,34.82h-5.96ZM2375.49,876.16c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M2390.29,928.62c2.12,1.34,5.58,2.28,9.24,2.28,5.86,0,10.45-2.97,12.52-12.4l1.15-5.21h-.18c-3.05,4.99-7.29,7.4-12.11,7.4-7,0-10.6-5.89-10.61-12.06-.02-11.86,8.63-23.53,22.11-23.53,4.04,0,8.44,1.13,11.18,2.43l-5.34,28.78c-1.4,7.38-3.4,12.47-7.02,15.59-3.48,3.01-8.19,3.86-12.16,3.86-4.24,0-8.26-.98-10.44-2.46l1.67-4.67ZM2417.05,891.06c-1.1-.55-3.26-1.19-5.76-1.19-8.71,0-14.71,9.11-14.75,17.71-.03,3.86,1.37,8.35,6.67,8.35s10.33-6.47,11.62-13.27l2.22-11.6Z'
				className='shape'
			/>
			<path
				d='M2456.42,920.71c-.03-2.1.33-5.39.78-9h-.15c-3.76,7.23-8.57,9.79-13.48,9.79-6.17,0-10.01-4.9-10.01-11.51,0-12.13,8.93-24.9,24.08-24.9,3.34,0,6.98.57,9.4,1.32l-3.55,18.15c-1.15,6.06-1.63,12.28-1.47,16.14h-5.57ZM2460.29,890.34c-.84-.27-2.13-.49-4.14-.49-9.02,0-16.38,9.38-16.42,19.07-.03,3.89,1.35,7.68,5.95,7.68,5,0,10.85-6.49,12.59-15.75l2.02-10.51Z'
				className='shape'
			/>
			<path
				d='M2476.81,920.71l4.66-24.69c.77-3.87,1.25-7.25,1.64-10.13h5.36l-.9,6.84h.14c3.13-4.9,7.82-7.63,12.92-7.63,4.13,0,8.8,2.38,8.8,9.67,0,1.55-.28,3.76-.62,5.62l-3.87,20.33h-5.96l3.81-20.12c.24-1.35.47-2.97.47-4.46,0-3.49-1.35-6.07-5.46-6.07s-10.33,5.1-11.91,13.72l-3.14,16.93h-5.96Z'
				className='shape'
			/>
			<rect
				x='2530.01'
				y='1258'
				width='163.99'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M2577.35,1280.78c0,8.41-3.08,17.7-8.84,23.44-4.3,4.25-9.94,6.77-16.63,6.77-12.54,0-18.4-9.45-18.4-19.75,0-8.53,3.34-18.01,9.25-23.79,4.17-4.06,10.16-6.58,16.27-6.58,13.06,0,18.35,9.51,18.35,19.9ZM2547.12,1270.78c-4.67,4.68-7.37,13.21-7.37,19.99,0,7.89,3.5,15.17,13,15.17,4.13,0,8.06-1.79,11.08-4.85,4.58-4.59,7.23-13.31,7.23-20.07s-2.26-15.11-12.86-15.11c-4.31,0-8.11,1.88-11.09,4.86Z'
				className='shape'
			/>
			<path
				d='M2586.34,1310.2l9.72-51.12h5.97l-4.35,22.44h.14c2.99-4.23,7.19-6.93,12.44-6.93,3.95,0,8.67,2.39,8.67,9.33,0,1.86-.23,4.13-.58,5.89l-3.87,20.39h-5.96l3.82-20.12c.25-1.27.47-2.88.47-4.81,0-3.2-1.54-5.72-5.41-5.72-4.62,0-10.41,5.4-11.86,13.2l-3.25,17.45h-5.96Z'
				className='shape'
			/>
			<path
				d='M2630.55,1310.2l6.65-34.82h5.96l-6.65,34.82h-5.96ZM2638.3,1265.66c.03-2.3,1.77-4.04,3.93-4.04s3.56,1.57,3.56,3.75c-.08,2.35-1.75,4.02-4.05,4.02-2.11,0-3.47-1.61-3.43-3.73Z'
				className='shape'
			/>
			<path
				d='M2686.21,1289.07c0,10.76-7.64,21.92-19.35,21.92-8.72,0-13.6-6.46-13.6-14.3,0-11.51,7.99-22.11,19.32-22.11,9.39,0,13.63,7.1,13.63,14.48ZM2659.43,1296.46c0,5.66,3.15,9.8,8.25,9.8,7.02,0,12.36-9.11,12.36-17.21,0-4.07-1.88-9.74-8.12-9.74-7.53,0-12.5,9.16-12.5,17.14Z'
				className='shape'
			/>
		</svg>
	);
};

MidwestMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default MidwestMap;
